
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';

import formHelper from '../../../js/classroom/classroom.helper';
import {classroomApi} from '@/api';

@Component
export default class Classes extends Vue {
    //===================================data区域begin
    operationName: string = '教室新增';
    operationType: any = 'new';
    classForm: any = formHelper.form;
    pageData: any = {
        roomTypeList: []
    };
    formRules: any = formHelper.formRules;
    classId: any = '';
    schoolId: any = '';
    //===================================data区域end

    //===================================computed区域begin

    //===================================computed区域end

    //===================================methods区域begin

    // 保存新增内容到接口表单
    saveForm() {
        let me = this;
        let formData = formHelper.convertDbForm(this.classForm);
        formData.schoolId = me.schoolId;
        (this.$refs.classForm as any).validate((valid: any) => {
            if (!!valid === false) {
                console.log('error...........');
                return;
            }
            classroomApi.saveClasses({
                context: this,
                data: formData,
                success(data: any, parameters: any) {
                    me.$message.success('操作成功');
                    me.$router.go(-1);
                },
                error(error: any, message: string, parameters: any) {
                    me.$message.error(message);
                }
            });
        });
    }
    onCancel() {
        this.$router.go(-1);
    }

    initForm() {
        let me = this;
        console.log('初始化表单');
        //如果是编辑或者查看，根据id查询数据
        if (me.operationType == 'edit') {
            classroomApi.getClasses({
                context: this,
                urlParamObj: {
                    _id: me.classId
                },
                success(data: any, parameters: any) {
                    me.classForm = formHelper.dbToForm(data.data, me.classForm);
                },
                error(error: any, message: string, parameters: any) {
                    me.$message.error(message);
                }
            });
        } else {
            me.classForm = {};
        }
    }

    //===================================methods区域end

    created() {
        let me = this;
        let state = me.$app.getState();
        me.schoolId = state.schoolId;
        console.log('操作类型：' + this.$route.query.type);
        this.operationType = this.$route.query.type;
        this.classId = this.$route.query.classId || 0;
        if (this.operationType == 'edit') {
            this.operationName = '教室编辑';
        } else {
            this.operationName = '教室新增';
        }
        this.initForm();
        this.$pageHelper.loadCodes({
            context: me,
            multipleCodeStr: 'classroom_type',
            success(codesJson: any) {
                me.$pageHelper.initPageDataItem(me.pageData.roomTypeList, codesJson, 'classroom_type', false); //教室类型
                console.log(me.pageData.roomTypeList);
            }
        });
    }
}
